// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Kiválasztás',
    titleLinkTooltip: 'Ugrás a következő oldalra',
    collapseCardTooltip: 'A kártya összecsukása',
    expandCardTooltip: 'A kártya kibontása'
  },
  CardList: {
    loadMore: 'Továbbiak betöltése',
    notFound: 'Nem találhatóak elemek.',
    toolbarSelect: 'Kiválasztás',
    viewCards: 'Kártyák',
    viewTiles: 'Csempék',
    viewList: 'Lista',
    toolbarView: 'Nézet'
  },
  ClosingConfirmation: {
    confirm: 'Elhagyás',
    cancel: 'Vissza',
    content: 'Biztosan be akarja zárni és el akarja hagyni ezt az ablakot? Nem t6rténik meg az adatváltoztatások mentése.'
  },
  Cuttable: {
    showMore: 'Több információ megjelenítése',
    showLess: 'Kevesebb megjelenítése'
  },
  Dialog: {
    cancelButton: 'Mégse'
  },
  DrawerProgress: {
    cancelButton: 'Mégse'
  },
  Dropdown: {
    close: 'Bezárás'
  },
  Form: {
    submitButton: 'Mentés',
    applyButton: 'Alkalmaz',
    cancelButton: 'Mégse'
  },
  FormField: {
    clear: 'Törlés',
    remove: 'Eltávolítás',
    addMore: 'Eggyel több hozzáadása'
  },
  FormFieldPassword: {
    improvePassword: 'Jelszava javítása érdekében:',
    passwordTooShort: 'Hosszabbítsa meg a jelszót.',
    lettersLowerCase: 'Legalább egy kisbetűt használjon.',
    lettersUpperCase: 'Legalább egy nagybetűt használjon.',
    numbers1: 'Legalább egy számot használjon.',
    numbers3: 'Legalább három számot használjon.',
    specialChar1: 'Legalább egy speciális karaktert használjon (például: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Legalább két speciális karaktert használjon (például: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Nagy- és kisbetűket használjon.',
    comboLettersAndNumbers: 'Számokat és karaktereket használjon.',
    comboLettersNumbersSpecial: 'Számoka, karaktereket és speciális karaktereket használjon.',
    yourPasswordIsStrong: 'A hossza növelésével még erősebbé teheti.',
    passwordStrength: '%%strength%% a jelszó erőssége.',
    strengthVeryStrong: 'NAGYON ERŐS',
    strengthStrong: 'ERŐS',
    strengthVeryWeak: 'NAGYON GYENGE',
    strengthWeak: 'GYENGE',
    strengthMedium: 'KÖZEPES',
    hidePassword: 'Jelszó elrejtése',
    showPassword: 'Jelszó megjelenítése',
    generateButton: 'Létrehozás',
    copyButtonHint: 'Jelszó másolása',
    copySuccessToast: 'Megtörtént a jelszó másolása.',
    generateButtonHint: 'Egy erős jelszó létrehozása'
  },
  InPlaceEdit: {
    editButtonHint: 'Érték szerkesztése',
    okButtonHint: 'Módosítások mentése',
    cancelButtonHint: 'Módosítások elvetése'
  },
  InputFile: {
    browseButton: 'Fájlválasztás folyamatban'
  },
  List: {
    totalRows: '%%totalRows%% elem összesen',
    selectedRows: '%%selectedRows%% / %%totalRows%% elem van kiválasztva.',
    all: 'Az összes',
    allItemsOnPageSelected: 'Az oldalon található összes elem kiválasztásra került',
    allItemsSelected: 'Az összes elem kiválasztásra került',
    selectAllItems: 'Az összes elem kiválasztása',
    selectAllItemsOnPage: 'Az oldalon található összes elem kiválasztása',
    deselectAll: 'Kijelölés megszüntetése'
  },
  ListEmptyView: {
    filteredTitle: 'Nem találhatóak a szűrővel egyező elemek.',
    emptyTitle: 'Úgy látszik, hogy semmi sincs itt.',
    filteredDescription: 'Finomítsa a lekérdezést, vagy távolítsa el a szűrőből a kritériumokat, majd próbálja meg újból.'
  },
  ListOperation: {
    cancelButton: 'Mégse'
  },
  Pagination: {
    totalShort: '/ %%total%%',
    itemsPerPage: 'Elem oldalanként',
    all: 'Az összes',
    total: '%%current%% / %%total%% oldal'
  },
  ProgressDialog: {
    closeButton: 'Bezárás',
    cancelButton: 'Mégse'
  },
  Select: {
    noOptions: 'Nincsenek választási lehetőségek.',
    placeholder: 'Kiválasztás folyamatban'
  },
  SpotPopup: {
    total: '%%current%% / %%total%%'
  },
  Toaster: {
    closeGroup: 'Csoport bezárása'
  }
};